const APP_BADGE_MAX = 99;

export const isAppBadgeSupported = (): boolean =>
  typeof navigator !== "undefined" && "setAppBadge" in navigator;

export const clearAppBadge = async (): Promise<void> => {
  if (!isAppBadgeSupported()) {
    return;
  }

  try {
    await navigator.clearAppBadge();
  } catch {
    /* badge is best-effort */
  }
};

export const syncAppBadge = async (count: number): Promise<void> => {
  if (!isAppBadgeSupported()) {
    return;
  }

  try {
    if (count <= 0) {
      await navigator.clearAppBadge();
      return;
    }

    await navigator.setAppBadge(Math.min(count, APP_BADGE_MAX));
  } catch {
    /* badge is best-effort */
  }
};
